

export enum UnitCost {
    cost590 = 590,
    cost560 = 560,
    cost450 = 450,
    cost420 = 420,
    cost280 = 280,
    cost270 = 270,
    cost200 = 200,
}


export enum UnitCostRange {
    high,
    middle,
    low,
}


export namespace UnitCost {
    export function toUnitCostRange(cost: UnitCost): UnitCostRange {
        if (500 <= cost) {
            return UnitCostRange.high;
        }

        if (cost < 300) {
            return UnitCostRange.low;
        }

        return UnitCostRange.middle;
    }
}
